import React, { useRef, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CompanyPicker from '../CompanyPicker'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'
import marker from '../../Assets/Images/MetodoEntrega/geo-alt-fill.svg'
import Loading from '../Loading/index'
import Submenu from '../UserSubMenu/index'
import './horizontalNav.css'
import BranchPicker from 'Components/BranchPicker'
import { Box, IconButton, Modal } from '@mui/material'
import GenericModal from 'Components/GenericModal'
import { setWareHouse } from 'redux/actions/companyAction'
import { t } from 'i18next'
import { refreshShoppingCart } from 'Utils/functions'
import MenuIcon from '@mui/icons-material/Menu'
import styles from './horizontalNav.module.css'

function HorizontalNav({ home, handleDrawer, showChangeBranch }) {
  // USER STATE REDUX
  const { user } = useSelector(state => state.login)
  const customerId = useSelector(
    state => state.cotizacion?.QuoteHeader?.CustomerId
  )
  const warehouses = useSelector(
    state => state?.login?.user?.CustomerInfo?.Warehouses
  )
  const company = useSelector(state => state?.company?.CompanyCode)
  const menuRef = useRef()

  const [open, setOpen] = useState(false)
  const [companyOpen, setCompanyOpen] = useState(false)
  const [branchOpen, setBranchOpen] = useState(false)
  const selectedCompany = useSelector(state => state?.company)

  const [currentWarehouse, setCurrentWarehouse] = useState(selectedCompany)
  const [showAlertModalBranch, setShowAlertModalBranch] = useState(false)

  const companies = useSelector(
    state => state?.login?.user?.CustomerInfo?.Companies
  )

  const cart = useSelector(state => state.cart.cart)

  useEffect(() => {
    companies?.forEach(company => {
      if (company?.ProfileImage && company?.IsVisibleInPortalVAD) {
        const img = new Image()
        img.src = company.ProfileImage
      }
    })
  }, [companies])

  const handleOpen = () => {
    setOpen(!open)
  }

  const handleCompany = () => {
    setCompanyOpen(!companyOpen)
  }
  const handleBranch = () => {
    setBranchOpen(!branchOpen)
  }
  const dispatch = useDispatch()

  const setSelectedWarehouse = () => {
    dispatch(setWareHouse(currentWarehouse))
    setBranchOpen(false)
    setShowAlertModalBranch(false)
    refreshShoppingCart({ cart, customerId, dispatch })
  }

  const setSelectedWarehouseBranch = warehouse => {
    dispatch(setWareHouse(warehouse))
    setBranchOpen(false)
    setShowAlertModalBranch(false)
    refreshShoppingCart({ cart, customerId, dispatch })
  }

  return (
    <div data-testid="horizontal-nav-wrapper">
      {user ? (
        <nav
          className="horizontal-navbar"
          data-testid="container-horizontal-nav">
          <Box
            component="ul"
            className="horizontal-icons-container"
            data-testid="container-horizontal-icons"
            sx={{
              paddingLeft: {
                xs: '36px',
                sm: '106px',
              },
            }}>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              edge="start"
              onClick={handleDrawer}
              data-testid="btn-open-drawer"
              sx={{ display: { xs: 'flex', sm: 'none' }, fontSize: '30px' }}>
              <MenuIcon
                sx={{
                  fontSize: '20px',
                }}
              />
            </IconButton>
            <li>
              <Box
                component="div"
                data-testid="btn-company-picker"
                sx={{
                  maxWidth: {
                    xs: '130px',
                    sm: '221.81px',
                  },
                }}
                className="h-nav-icon tenant icon-branch-div"
                onClick={companies?.length > 1 ? handleCompany : null}>
                <img
                  className="display-image"
                  src={selectedCompany?.ProfileImage}
                  alt="logo"
                  data-testid="img-company-logo"
                />
                {companies?.length > 1 && (
                  <FontAwesomeIcon
                    className="down-chev"
                    icon={faChevronDown}></FontAwesomeIcon>
                )}
              </Box>
            </li>
            {showChangeBranch ? (
              <li>
                <div
                  className="h-nav-icon tenant row"
                  onClick={handleBranch}
                  data-testid="btn-branch-picker">
                  <div className="col-2">
                    <img
                      src={marker}
                      alt="marcador"
                      data-testid="img-branch-marker"
                    />
                  </div>

                  <div className="col-10">
                    <span className="row">
                      {' '}
                      {t('CHANGE_BRANCH.SEE_THE_INVENTARY')}
                    </span>

                    <strong data-testid="warehouse-description" className="row">
                      {selectedCompany?.WarehouseDescription}
                    </strong>

                    {!!warehouses.length && (
                      <span
                        data-testid="change-branch-text"
                        className={`row ${styles.changeBranchText}`}>
                        {t('CHANGE_BRANCH.CHOSE_ANOTHER_BRANCH')}
                      </span>
                    )}
                  </div>
                </div>
              </li>
            ) : null}
            <li>
              <div
                className="h-nav-icon user"
                onClick={handleOpen}
                data-testid="user-menu"
                ref={menuRef}>
                <p data-testid="profile-miniature" className="profile-pic">
                  {user.CustomerInfo.FirstName[0]}
                  {user.CustomerInfo.LastName[0]}
                </p>
                <Box
                  component="p"
                  sx={{
                    display: {
                      xs: 'none',
                      sm: 'block',
                    },
                  }}
                  data-testid="username"
                  className="username">
                  {user.CustomerInfo.FirstName} {user.CustomerInfo.LastName}
                </Box>
              </div>
            </li>
          </Box>
          <Submenu show={open} setShow={setOpen} menuRef={menuRef} />
          <div data-testid="container-modals">
            <Modal
              open={companyOpen}
              onClose={() => {
                setCompanyOpen(false)
              }}
              data-testid="modal-company-picker"
              BackdropProps={{
                style: { backgroundColor: 'rgba(0, 0, 0, 0)' },
              }}>
              <Box>
                <CompanyPicker
                  home={home}
                  show={companyOpen}
                  setShow={setCompanyOpen}
                  companies={companies}
                />
              </Box>
            </Modal>
            <Modal
              onClose={handleBranch}
              open={branchOpen}
              data-testid="modal-branch-picker"
              BackdropProps={{
                style: { backgroundColor: 'rgba(0, 0, 0, 0)' },
              }}
              className="modal-up">
              <Box>
                <BranchPicker
                  home={home}
                  showMB={branchOpen}
                  setShowMB={setBranchOpen}
                  company={company}
                  setShowAlertModalBranch={setShowAlertModalBranch}
                  setCurrentWarehouse={setCurrentWarehouse}
                  setSelectedWarehouse={setSelectedWarehouseBranch}
                />
              </Box>
            </Modal>
          </div>
        </nav>
      ) : (
        <Loading />
      )}
      <Modal
        open={showAlertModalBranch}
        onClose={() => {
          setShowAlertModalBranch(false)
        }}
        data-testid="modal-confirm-branch-change">
        <Box>
          <GenericModal
            hideCheck={true}
            showCaution={true}
            setConfirm={setSelectedWarehouse}
            setIsOpen={() => setShowAlertModalBranch(false)}
            text={t('GENERIC_MODAL.ARE_SURE_TO_CHANGE')}
            mostrarButtons={true}
            text2={t('GENERIC_MODAL.WANT_TO_CONTINUE')}></GenericModal>
        </Box>
      </Modal>
    </div>
  )
}

export default HorizontalNav
